// extracted by mini-css-extract-plugin
module.exports = {"base":"DragAndDrop_base__1Bt5z","footer":"DragAndDrop_footer__1rkxg","columns":"DragAndDrop_columns__2nC5Z"};